import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://seobix.com";

function normalizePathname(pathname) {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/, "");
}

function buildCanonicalUrl(pathname) {
  const normalizedPathname = normalizePathname(pathname);
  return normalizedPathname === "/"
    ? `${SITE_URL}/`
    : `${SITE_URL}${normalizedPathname}`;
}

function CanonicalManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonicalUrl = buildCanonicalUrl(pathname);
    const canonicalLinks = document.head.querySelectorAll('link[rel="canonical"]');
    const canonicalLink = canonicalLinks[0] || document.createElement("link");

    canonicalLinks.forEach((link, index) => {
      if (index > 0) {
        link.remove();
      }
    });

    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", canonicalUrl);

    if (!canonicalLink.parentNode) {
      document.head.appendChild(canonicalLink);
    }
  }, [pathname]);

  return null;
}

export default CanonicalManager;
